import { Fragment, useEffect, useState } from "react";
import TableCell from "@mui/material/TableCell";
import { useTranslation } from "react-i18next";
import useAxios from "../../../hook/useAxios";
import DeleteAlert from "../../ErrorAndAlert/DeleteAlert";
import ActionItem from "../../Global/ActionItem";
import { toast } from "react-toastify";
import { DepartmentRecord } from "../../../type/departmentRecord";
import { Link } from "react-router-dom";

const DepartmentTableItem: React.FC<{
  department: DepartmentRecord;
  fetchData: () => void;
  lastIndex: number;
}> = ({ department, fetchData: propFetchData, lastIndex }) => {
  const { i18n, t } = useTranslation();
  const [showDelete, isShowDelete] = useState<boolean>(false);
  const { response: deleteR, fetchData } = useAxios(
    process.env.REACT_APP_API_URL +
    `/api/admin/departments/${department.id}/delete/`,
    "DELETE",
    false,
    `${t("Message.Successful delete")}`,
    true,
    true
  );
  useEffect(() => {
    if (deleteR) {
      isShowDelete(false);
      propFetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteR]);

  const deleteAction = () => {
    if (department.is_deletable) {
      isShowDelete(true);
    } else {
      toast.error(
        t(
          "Message.Delete province"
        )
      );
    }
  };

  const hide = () => {
    isShowDelete(false);
  };

  const deleteItem = () => {
    fetchData({});
  };
  const active =
    i18n.language === "fr"
      ? department.is_active_transes.fr
      : department.is_active_transes.en;
  return (
    <Fragment>
      <TableCell align="left">{department.project_country}</TableCell>
      <TableCell>
        <Link
          className="hover:text-[#0884B8]"
          to={`/setting/provinces/view-province/${department.slug}`}
        >
          {department.name}
        </Link>
      </TableCell>
      <TableCell>
        <p
          className={`${department.is_active_transes.en === "Active"
            ? "bg-ph-toggle-bg-green text-ph-toggle-text-green"
            : "bg-ph-toggle-bg-red text-ph-red-warning"
            } text-center w-16 py-1 rounded-xl`}
        >
          {active}
        </p>
      </TableCell>

      <TableCell align="right">
        <ActionItem
          delete={true}
          editLink={`/setting/provinces/edit-province/${department.slug}`}
          deleteAction={deleteAction}
          view=""
          viewLink={`/setting/provinces/view-province/${department.slug}`}
          viewDepartment={t("Province.View") + ""}
          historyLink=""
          viewHistory=""
        />
      </TableCell>
      {showDelete && (
        <DeleteAlert
          type={t("PlantingFilter.Province")}
          hide={hide}
          deleteAction={deleteItem}
        />
      )}
    </Fragment>
  );
};

export default DepartmentTableItem;
